export const PREFERRED_DISPLAY_LANGUAGE = 'ja'
export const MAX_WORD_LENGTH = 4
export const MAX_CHALLENGES = 12
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const GAME_LOST_INFO_DELAY = (MAX_WORD_LENGTH + 1) * REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
export const ENABLE_MIGRATE_STATS = true
export const ENABLE_ARCHIVED_GAMES = true
export const BLOWFISH_KEY = 'xcQUAHsik#Thq&LG*8es2DsZ$3bw^e'
export const BLOWFISH_IV = '#45XmF^w'
export const AD_CLIENT_ID = process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT_ID!
export const AD_SLOT_TOP_BANNER_ID = '6226201186'
export const AD_SLOT_BOTTOM_BANNER_ID = '4913119517'
export const AD_SLOT_LEFT_SKIN_ID = '2777910761'
export const AD_SLOT_RIGHT_SKIN_ID = '4289253230'
